import { FormUploadCode } from '../codeHighlights/forms/FormUploadCode';

const UploadForm = () => {
  return (
    <>
      <h2 className="mt-4">Form Upload</h2>
      <form noValidate={true} method="" id="bootstrapForm2">
        <div className="mb-3">
          <label htmlFor="formFile" className="form-label">
            Default file input example
          </label>
          <input className="form-control" type="file" id="formFile" />
        </div>
        <div className="mb-3">
          <label htmlFor="formFileMultiple" className="form-label">
            Multiple files input example
          </label>
          <input
            className="form-control"
            type="file"
            id="formFileMultiple"
            multiple
          />
        </div>
        <div className="mb-3">
          <label htmlFor="formFileDisabled" className="form-label">
            Disabled file input example
          </label>
          <input
            className="form-control"
            type="file"
            id="formFileDisabled"
            disabled
          />
        </div>
        <div className="mb-3">
          <label htmlFor="formFileSm" className="form-label">
            Small file input example
          </label>
          <input
            className="form-control form-control-sm"
            id="formFileSm"
            type="file"
          />
        </div>
        <div>
          <label htmlFor="formFileLg" className="form-label">
            Large file input example
          </label>
          <input
            className="form-control form-control-lg"
            id="formFileLg"
            type="file"
          />
        </div>
      </form>

      <div className="mt-5">
        <FormUploadCode />
      </div>
    </>
  );
};

export default UploadForm;
